/* eslint-disable eqeqeq */
import React, { FC } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { withProcedureWraper } from "../../../..";
import { Routes } from "../../../../../../AppRoutes";
import { Box } from "../../../../../../components/box";
import { Icon } from "../../../../../../components/icon";
import { CreateForm } from "./create-form";
import { EditForm } from "./edit-form";

export const Create: FC = withProcedureWraper(() => {
  const { id } = useRouteMatch().params as any;
  const history = useHistory();

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div
              className="btnBack"
              onClick={() =>
                history.push(Routes.summaryEmployeeRequestPage.path)
              }
            >
              <Icon.ArrowLeft />
            </div>
            {id != 0
              ? "CHỈNH SỬA BẢNG ĐĂNG KÝ NHÂN SỰ THAM GIA KHÓA HỌC"
              : "TẠO BẢNG ĐĂNG KÝ NHÂN SỰ THAM GIA KHÓA HỌC"}
          </div>
        </div>
        <Box title="Nội dung">
          {id == 0 && <CreateForm />}
          {id != 0 && <EditForm />}
        </Box>
      </div>
    </div>
  );
});
